module.exports = __webpack_public_path__ + "static/media/FILMM2023.d3f39b56.pdf";